"use client";
import { ToastType } from "components/toast/types";
import dynamic from "next/dynamic";
import { useMemo, useState } from "react";

const DynamicToast = dynamic(() => import("components/toast"), {
  ssr: false,
});
const useToast = (key: string) => {
  const [showToast, setShowToast] = useState<{
    open: boolean;
    message: string;
    toastType: ToastType;
  }>({
    open: false,
    message: "",
    toastType: "warning",
  });

  const updateToast = (
    open: boolean,
    message: string,
    toastType: ToastType = "warning"
  ) => {
    setShowToast({
      open,
      message,
      toastType,
    });
  };

  const toastComp = useMemo(
    () => (
      <DynamicToast
        key={key}
        show={showToast.open}
        message={showToast.message}
        toastType={showToast.toastType}
        onClose={() => setShowToast({ ...showToast, open: false })}
      />
    ),
    [showToast, key]
  );

  return {
    showToast,
    updateToast,
    toastComp,
  };
};

export default useToast;
